export type MonumentTransitionMode = 'none' | 'locked' | 'redirect'

export interface CoincraftAccess {
    mode: MonumentTransitionMode
    allowed: boolean
}

export const monumentLoginUrl =
    process.env.REACT_APP_MONUMENT_LOGIN_URL || 'https://app.monument.so'

export const handleMonumentTransitionMode = (
    mode: string | null | undefined
): boolean => {
    if (mode === 'redirect') {
        window.location.replace(monumentLoginUrl)
        return true
    }

    return mode === 'locked'
}
